module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-diamond-44983783.svg";